module.exports = __webpack_public_path__ + "img/SEGURIFY_GIF_COMPARADOR.da0bc43b.gif";